/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Meta_Description_AllInputs */

const en_directory_meta_description_all = /** @type {(inputs: Directory_Meta_Description_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainers, dieticians and physios with prices and open times. Book online, no account needed to browse.`)
};

const pl_directory_meta_description_all = /** @type {(inputs: Directory_Meta_Description_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenerzy, dietetycy i fizjoterapeuci z cenami i wolnymi terminami. Umów się online, przeglądasz bez konta.`)
};

/**
* | output |
* | --- |
* | "Trainers, dieticians and physios with prices and open times. Book online, no account needed to browse." |
*
* @param {Directory_Meta_Description_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_meta_description_all = /** @type {((inputs?: Directory_Meta_Description_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Meta_Description_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_meta_description_all(inputs)
	return en_directory_meta_description_all(inputs)
});